﻿package com.mgacreative.hotelru.shared.ui.designsystem.components

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.mgacreative.hotelru.shared.ui.designsystem.i18n.AppLanguage
import com.mgacreative.hotelru.shared.ui.designsystem.i18n.AppLocalizationManager

@Composable
fun LanguageSelectorDropdown(
    modifier: Modifier = Modifier
) {
    val currentLanguage by AppLocalizationManager.currentLanguage.collectAsState()
    var expanded by remember { mutableStateOf(false) }

    Box(modifier = modifier) {
        Row(
            modifier = Modifier
                .clip(RoundedCornerShape(8.dp))
                .background(Color(0xFFF1F5F9))
                .clickable { expanded = true }
                .padding(horizontal = 8.dp, vertical = 4.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Text(currentLanguage.flag, fontSize = 14.sp)
            Spacer(modifier = Modifier.width(4.dp))
            Text(currentLanguage.code.uppercase(), fontWeight = FontWeight.Bold, fontSize = 12.sp, color = Color(0xFF1E293B))
        }

        DropdownMenu(
            expanded = expanded,
            onDismissRequest = { expanded = false }
        ) {
            AppLanguage.entries.forEach { lang ->
                DropdownMenuItem(
                    text = {
                        Row(verticalAlignment = Alignment.CenterVertically) {
                            Text(lang.flag, fontSize = 16.sp)
                            Spacer(modifier = Modifier.width(8.dp))
                            Text(lang.displayName, fontWeight = if (lang == currentLanguage) FontWeight.Bold else FontWeight.Normal)
                        }
                    },
                    onClick = {
                        AppLocalizationManager.setLanguage(lang)
                        expanded = false
                    }
                )
            }
        }
    }
}

